"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/breadcrumb/style");
var _breadcrumb = _interopRequireDefault(require("antd/lib/breadcrumb"));
var _react = _interopRequireWildcard(require("react"));
var _loadJs = require("../../utils/loadJs");
require("./style.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FOOT_URL = '//static.gyyx.cn/Stage/public_bottom_data_cms.txt';
/**
 * 当加载数据失败时使用此
 */
var footDefaultData = {
  id: 'default',
  title: '默认底部',
  slogan: '抵制不良游戏，拒绝盗版游戏；注意自我保护，谨防上当受骗；适度游戏益脑，沉迷游戏伤身；合理安排时间，享受快乐生活！',
  reginfo: "互联网出版经营许可证 新出网证(京)字048号 电信与信息服务业务经营许可证<br/><img src='//static.gyyx.cn/img/gwab.png'><a href='//www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020128' target='_blank'>京公网安备11010802020128号</a> 京ICP证060877 <a href='//beian.miit.gov.cn' target=\"_blank\">京ICP备11014625号-1</a> <a href='//static.gyyx.cn/img/yyzz.jpg' target='_blank'>北京光宇在线科技有限责任公司</a> 版权所有<br/>© 光宇游戏 版权所有",
  data: [{
    title: '电子营业执照',
    url: '',
    image: ''
  }, {
    title: '网络公安',
    url: '',
    image: ''
  }, {
    title: '公司简介',
    url: '//www.gyyxol.cn/channels/83.html',
    image: ''
  }, {
    title: '家长监护',
    url: '//kf.gyyx.cn/jianhu/jz_2010.html',
    image: ''
  }, {
    title: '诚聘英才',
    url: '//zhaopin.gyyx.cn/',
    image: ''
  }, {
    title: '客服帮助',
    url: '//kf.gyyx.cn/',
    image: ''
  }, {
    title: '商务合作',
    url: '//www.gyyxol.cn/channels/87.html',
    image: ''
  }]
};
/**
 * page foot
 */
var index = function index(props) {
  var _useState = (0, _react.useState)(footDefaultData),
    _useState2 = _slicedToArray(_useState, 2),
    footData = _useState2[0],
    setFootData = _useState2[1];
  /**
   * 加载页尾数据
   */
  var handleInit = function handleInit() {
    (0, _loadJs.loadJs)({
      src: FOOT_URL,
      cb: function cb(res) {
        var bottomData = window.bottomdata;
        bottomData.forEach(function (data, index) {
          if (props.footId === data['id']) {
            setFootData(data);
          }
        });
      }
    }).catch(function (res) {
      console.log('error', res);
    });
  };
  /**
   *
   */
  var handleStat = function handleStat() {
    var newNode = document.createElement('script');
    newNode.src = 'https://hm.baidu.com/hm.js?39e0fad2883ee9edb7bd5b2f6d09ee69';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode && s.parentNode.insertBefore(newNode, s);
  };
  /**
   * 首次加载时，进行初始化的内容
   */
  (0, _react.useEffect)(function () {
    handleInit();
    handleStat();
  }, []);
  var createMarkup = function createMarkup(text) {
    return {
      __html: text
    };
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_foot_nav"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_foot_bg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_foot_body"
  }, /*#__PURE__*/_react.default.createElement(_breadcrumb.default, {
    separator: /*#__PURE__*/_react.default.createElement("span", null, "|")
  }, footData.data.map(function (linkData, index) {
    if ('' !== linkData.url) {
      return /*#__PURE__*/_react.default.createElement(_breadcrumb.default.Item, {
        key: index
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: linkData.url,
        target: "_blank",
        title: linkData.title
      }, linkData.title));
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: createMarkup(footData.slogan)
  }), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: createMarkup(footData.reginfo)
  })));
};
var _default = index;
exports.default = _default;